import React, { useEffect, useState } from 'react';

const ProjectsSection = ({ lang }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);

  const PROJECTS_API = 'https://www.yam-ii.com/yam_api/manage_projects.php?action=get_projects';
  const LOCAL_SERVER_URL = 'https://www.yam-ii.com/yam_api/uploads/';

  useEffect(() => {
    let isMounted = true;
    const fetchProjects = async () => {
      try {
        const response = await fetch(PROJECTS_API);
        const data = await response.json();
        if (isMounted) setProjects(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Connection Error:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchProjects();
    return () => { isMounted = false; };
  }, []);

  const formatImageUrl = (url) => {
    if (!url) return 'https://via.placeholder.com/600x400?text=No+Image';
    const fileName = url.split(/[\\/]/).pop();
    return `${LOCAL_SERVER_URL}${fileName}`;
  };

  if (loading && projects.length === 0) return (
    <div style={{ textAlign: 'center', padding: '100px 0' }}>
      <div className="loader"></div>
    </div>
  );

  // تم تعطيل هذا السطر لضمان ظهور عنوان القسم دائماً وعدم اختفائه
  // if (!loading && projects.length === 0) return null;

  return (
    <section className="projects-section" id="projects">
      <div className="container">
        <div className="section-header">
           <span className="subtitle">{lang === 'ar' ? 'آخر المستجدات' : 'LATEST UPDATES'}</span>
           <h2 className="section-title">
             {lang === 'ar' ? 'الأخبار' : 'News'}
           </h2>
           <div className="title-underline"></div>
        </div>
        
        {/* رسالة بسيطة تظهر فقط إذا كانت المصفوفة فارغة */}
        {!loading && projects.length === 0 && (
          <p style={{ textAlign: 'center', color: '#666', marginTop: '20px' }}>
            {lang === 'ar' ? 'لا توجد أخبار متوفرة حالياً.' : 'No news available at the moment.'}
          </p>
        )}
        
        <div className="modern-projects-grid">
          {projects.map((proj) => (
            <div key={proj.id} className="modern-card" onClick={() => setSelectedProject(proj)}>
              <div className="card-image-wrapper">
                <img 
                  src={formatImageUrl(proj.image_url)} 
                  alt={proj.title_ar}
                  className="card-img"
                  loading="lazy"
                />
                <div className="card-overlay">
                   <div className="card-info">
                      <span className="card-tag">{lang === 'ar' ? proj.category_ar : proj.category_en}</span>
                      <h3 className="card-title">{lang === 'ar' ? proj.title_ar : proj.title_en}</h3>
                      <p className="card-date">📅 {proj.date}</p>
                      <button className="view-btn">{lang === 'ar' ? 'استكشف التفاصيل' : 'Explore Details'}</button>
                   </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* مودال التفاصيل بنفس الستايل الفخم */}
      {selectedProject && (
        <div className="modal-overlay active" onClick={() => setSelectedProject(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-modal-btn" onClick={() => setSelectedProject(null)}>&times;</button>
            <div className="modal-scroll-area">
              <div className="modal-image-box">
                  <img src={formatImageUrl(selectedProject.image_url)} alt="Detail" className="modal-actual-img" />
              </div>
              <div className="modal-text-body">
                <span className="modal-date-label">{selectedProject.date}</span>
                <h2 className="modal-main-title">{lang === 'ar' ? selectedProject.title_ar : selectedProject.title_en}</h2>
                <div className="modal-sep"></div>
                <p className="modal-description-full">{lang === 'ar' ? selectedProject.desc_ar : selectedProject.desc_en}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .projects-section { 
          padding: 100px 5%; 
          background: #fdfdfd; 
          direction: ${lang === 'ar' ? 'rtl' : 'ltr'}; 
          scroll-margin-top: 80px; 
        }
        .container { max-width: 1400px; margin: 0 auto; }
        
        .section-header { text-align: center; margin-bottom: 70px; }
        .subtitle { color: #d4af37; font-weight: 800; letter-spacing: 2px; font-size: 0.9rem; }
        .section-title { 
          color: #1a3a5a; 
          margin: 10px 0; 
          font-weight: 900; 
          font-size: clamp(2rem, 4vw, 3rem); 
        }
        .title-underline { width: 80px; height: 4px; background: #d4af37; margin: 0 auto; border-radius: 2px; }

        .modern-projects-grid { 
          display: grid; 
          grid-template-columns: repeat(auto-fill, minmax(min(100%, 400px), 1fr)); 
          gap: 25px; 
        }

        .modern-card { 
          position: relative; 
          height: 450px; 
          border-radius: 24px; 
          overflow: hidden; 
          cursor: pointer;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .card-image-wrapper { width: 100%; height: 100%; position: relative; }
        .card-img { width: 100%; height: 100%; object-fit: cover; transition: 0.8s cubic-bezier(0.2, 1, 0.3, 1); }

        .card-overlay { 
          position: absolute; 
          inset: 0; 
          background: linear-gradient(to top, rgba(13, 31, 51, 0.95) 10%, rgba(13, 31, 51, 0.4) 50%, transparent 100%); 
          display: flex; 
          align-items: flex-end; 
          padding: 40px; 
          opacity: 0.9;
          transition: 0.5s ease;
        }

        .card-info { transform: translateY(40px); transition: 0.5s ease; width: 100%; }
        .card-tag { 
          background: #d4af37; 
          color: #1a3a5a; 
          padding: 5px 15px; 
          border-radius: 50px; 
          font-size: 0.75rem; 
          font-weight: 800; 
          display: inline-block;
          margin-bottom: 15px;
        }
        .card-title { color: white; font-size: 1.6rem; font-weight: 700; margin-bottom: 10px; line-height: 1.3; }
        .card-date { color: rgba(255,255,255,0.7); font-size: 0.85rem; margin-bottom: 20px; }
        .view-btn { 
          background: transparent; 
          border: 1px solid #d4af37; 
          color: #d4af37; 
          padding: 10px 25px; 
          border-radius: 50px; 
          font-weight: 700; 
          cursor: pointer;
          opacity: 0;
          transition: 0.4s;
        }

        .modern-card:hover .card-img { transform: scale(1.1); }
        .modern-card:hover .card-overlay { background: linear-gradient(to top, rgba(13, 31, 51, 0.98) 30%, rgba(13, 31, 51, 0.2) 100%); }
        .modern-card:hover .card-info { transform: translateY(0); }
        .modern-card:hover .view-btn { opacity: 1; }

        .modal-overlay { position: fixed; inset: 0; background: rgba(13, 31, 51, 0.92); backdrop-filter: blur(10px); display: flex; align-items: center; justify-content: center; z-index: 99999; opacity: 0; pointer-events: none; transition: 0.4s; padding: 20px; }
        .modal-overlay.active { opacity: 1; pointer-events: auto; }
        .modal-content { background: #fff; width: 100%; max-width: 1000px; border-radius: 40px; overflow: hidden; max-height: 85vh; position: relative; }
        .modal-scroll-area { overflow-y: auto; max-height: 85vh; }
        .modal-image-box { width: 100%; height: 500px; background: #0d1f33; }
        .modal-actual-img { width: 100%; height: 100%; object-fit: contain; }
        .close-modal-btn { position: absolute; top: 25px; right: 25px; width: 50px; height: 50px; border-radius: 50%; background: #d4af37; color: #1a3a5a; border: none; font-size: 28px; cursor: pointer; z-index: 100; transition: 0.3s; }
        .close-modal-btn:hover { transform: rotate(90deg); background: #fff; }
        .modal-text-body { padding: 50px; }
        .modal-main-title { font-size: 2.5rem; color: #1a3a5a; font-weight: 900; margin: 15px 0; }
        .modal-sep { width: 100px; height: 6px; background: #d4af37; margin-bottom: 30px; border-radius: 3px; }
        .modal-description-full { font-size: 1.25rem; line-height: 1.8; color: #444; white-space: pre-wrap; }

        .loader { width: 60px; height: 60px; border: 6px solid #f3f3f3; border-top: 6px solid #d4af37; border-radius: 50%; animation: rotation 1s linear infinite; margin: auto; }
        @keyframes rotation { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

        @media (max-width: 768px) {
          .modern-card { height: 350px; }
          .card-overlay { padding: 25px; }
          .modal-text-body { padding: 30px; }
        }
      `}</style>
    </section>
  );
};

export default ProjectsSection;